<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.cache"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.cache"></router-view>
    <back-home v-if="isShow"></back-home>
  </div>
</template>
<script>
import BackHome from '@/components/BackHome'
import { mapState } from 'vuex'
export default {
  components: {
    BackHome
  },
  computed: {
    ...mapState(['isShow'])
  }
}
</script>
<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
